/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Consent_WhatInputs */

const en_us2_body_assessment_consent_what = /** @type {(inputs: Body_Assessment_Consent_WhatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The two photos (one from the front, one from the side) go with your height, weight, age and sex to MyPocketGym's own server at bf.mypocketgym.app, which computes your waist-to-height ratio and your body fat.`)
};

const pt_br2_body_assessment_consent_what = /** @type {(inputs: Body_Assessment_Consent_WhatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As duas fotos (uma de frente e uma de lado) vão junto com a sua altura, peso, idade e sexo para o servidor do próprio MyPocketGym, em bf.mypocketgym.app, que calcula a relação cintura/altura e o seu percentual de gordura.`)
};

const es_419_body_assessment_consent_what = /** @type {(inputs: Body_Assessment_Consent_WhatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las dos fotos (una de frente y una de lado) van junto con tu estatura, peso, edad y sexo al servidor propio de MyPocketGym, en bf.mypocketgym.app, que calcula tu relación cintura/estatura y tu porcentaje de grasa.`)
};

const pt_pt2_body_assessment_consent_what = /** @type {(inputs: Body_Assessment_Consent_WhatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As duas fotos (uma de frente e uma de lado) seguem, com a tua altura, peso, idade e sexo, para o servidor do próprio MyPocketGym, em bf.mypocketgym.app, que calcula a relação cintura/altura e a tua percentagem de gordura.`)
};

const fr_fr2_body_assessment_consent_what = /** @type {(inputs: Body_Assessment_Consent_WhatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les deux photos (une de face, une de profil) partent avec ta taille, ton poids, ton âge et ton sexe vers le serveur de MyPocketGym, bf.mypocketgym.app, qui calcule ton rapport tour de taille/taille et ton taux de masse grasse.`)
};

const de_de2_body_assessment_consent_what = /** @type {(inputs: Body_Assessment_Consent_WhatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die beiden Fotos (eins von vorne, eins von der Seite) gehen zusammen mit Größe, Gewicht, Alter und Geschlecht an MyPocketGyms eigenen Server unter bf.mypocketgym.app, der dein Taille-Größe-Verhältnis und deinen Körperfettanteil berechnet.`)
};

const it_it2_body_assessment_consent_what = /** @type {(inputs: Body_Assessment_Consent_WhatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le due foto (una frontale e una laterale) vanno, insieme ad altezza, peso, età e sesso, al server di MyPocketGym, su bf.mypocketgym.app, che calcola il rapporto vita/altezza e la tua percentuale di grasso.`)
};

/**
* | output |
* | --- |
* | "The two photos (one from the front, one from the side) go with your height, weight, age and sex to MyPocketGym's own server at bf.mypocketgym.app, which comp..." |
*
* @param {Body_Assessment_Consent_WhatInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_consent_what = /** @type {((inputs?: Body_Assessment_Consent_WhatInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Consent_WhatInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_consent_what(inputs)
	if (locale === "es-419") return es_419_body_assessment_consent_what(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_consent_what(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_consent_what(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_consent_what(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_consent_what(inputs)
	return en_us2_body_assessment_consent_what(inputs)
});
export { body_assessment_consent_what as "body-assessment.consent_what" }